<template>
  <TableTemplate class="w-min-[600px] w-full h-full" :isLoading="waiting">
    <template v-slot:table-content>
      <thead
        class="divide-y bg-gray border-b-2 sticky top-0 select-none"
        ref="thead"
      >
        <tr>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Назва</p>
            </div>
          </th>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer w-[200px]"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Кількість тренуваннь</p>
            </div>
          </th>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Тип тренуваннь</p>
            </div>
          </th>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Строк дії</p>
            </div>
          </th>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Ціна</p>
            </div>
          </th>
          <th
            class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer"
          >
            <div class="cursor-pointer flex items-center gap-4 h-full">
              <p>Дії</p>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100" ref="tbody">
        <tr
          v-for="product in products"
          :key="product.id"
          class="hover:bg-blue-200 cursor-pointer h-12 select-none"
        >
          <td class="text-left flex items-center p-3">{{ product.name }}</td>
          <td class="text-left p-3">{{ product.trainings === "unlimited" ? "Безліміт" : product.trainings }}</td>
          <td class="text-left p-3">
            {{ getVerboseTrainingType(product.training_type) }}
          </td>
          <td class="text-left p-3">{{ product.validity }} днів</td>
          <td class="text-left p-3">{{ product.cost }} грн</td>
          <td class="text-left p-3 flex gap-2">
            <button
              class="bg-green-200 px-2 rounded hover:scale-105 transition duration-300"
              @click="chooseEditedProduct(product)"
            >
              Детальніше
            </button>
            <button
              v-if="user[0].role == 'superadmin'"
              class="bg-red-200 px-2 rounded hover:scale-105 transition duration-300"
              @click="deleteProduct(product)"
            >
              Видалити
            </button>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-slot:pagination>
      <Pagination
        v-if="pageLength > 1"
        v-model="currentPage"
        :current-page="currentPage"
        :pages="pageLength"
        @update:modelValue="setCurrentPage"
      />
    </template>
  </TableTemplate>
</template>

<script>
import { TRAINING_TYPES } from "./Constants";
import Pagination from "../reusable/Pagination.vue";
import TableTemplate from "../reusable/TableTemplate.vue";
import { mapState } from "vuex";
export default {
  name: "PlansTable",
  components: {
    Pagination,
    TableTemplate,
  },
  props: {
    products: Array,
    trainingType: Number,
    totalRecords: Number,
    currentPage: Number,
  },
  data: function () {
    return {
      recordsPerPage: 13,
      waiting: false,
    };
  },
  methods: {
    getVerboseTrainingType(type) {
      return TRAINING_TYPES[type];
    },
    setCurrentPage(newVal) {
      let el = this.$refs.thead;
      if (el)
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      this.$emit("page-change", newVal);
    },
    chooseEditedProduct(product) {
      this.$emit("choose-product", product, 1);
    },
    async deleteProduct(product) {
      try {
        let confirm = window.confirm(
          `Ви впевнені, що хочете видалити товар ${product.name}?`,
        );
        if (!confirm) return;
        await this.$api.products.deleteProduct(product.id);
        this.$emit("product-deleted");
      } catch (error) {
        this.$emit("show-alert", "Помилка при видаленні товару", "bg-red-200");
        console.error(error);
      }
    },
  },
  computed: {
    ...mapState(["user"]),
    pageLength: function () {
      return Math.ceil(this.totalRecords / this.recordsPerPage);
    },
  },
};
</script>

<style scoped></style>
